<template>
    <div class="train">
        <div class="trainLeft">
            <div class="trainHead">
                <div class="title">培训园地</div>
                <div class="more" @click="moreVideos" >更多 +</div>
            </div>
            <div style="font-weight: bold;font-size: 16px;color: #00A287;margin-top: 30px;">培训精学政府采购，助力高效规范采购</div>
            <div style="font-size: 14px;color: #000000;margin-top: 16px;">线上培训与政府采购的关系，同时强调了培训对于提高采购效率和规范性的重要性。</div>
            <img src="../../assets/img/newHome/trainImg.png" @click="viewCourse" style="margin-top: 60px;cursor: pointer;width:100%"/>
        </div>

        <div class="trainRight">
            <div class="trainRightLayout" >
                <el-row :gutter="16" style="width:100%">
                    <el-col :span="12" v-for="(item, index) in videoList" :key="index" >
                        <div class="imgLayout" @click="viewCourse"  >
                            <img class="imgStyle" :src="item.coverUrl" alt="描述图片的文字" />
                            <div  class="imgBottom">
                                <div style="margin-left:10px">{{item.trainingTime}}</div>
                                <div style="margin-right:10px">• {{item.instructor}}</div>
                            </div>
                        </div>
                        <div class="literalDescription" >
                            <div class="type"  >
                                {{item.trainingType === "1" ? "直播" : item.trainingType === "2" ? "录播"  : item.trainingType === "3" ? "线下" : ""}}
                            </div>
                            <el-tooltip  effect="dark" placement="top">
                                <div  slot="content">
                                    {{ item.courseName }}
                                </div>
                                <span class="title" >{{ item.courseName }}</span>
                            </el-tooltip>
                        </div>
                    </el-col>

                </el-row>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import { prefixedUrlAsset } from '@/utils/constants';
export default {
    components: {},
    computed: {
    
    },
    data() {
        return {
            videoList:[]
        };
    },
 
    created() {
        
        
    },
    mounted() {
        this.getVideoList()
    },
    methods: {
        getVideoList(){
            //获取视频
            this.axios.get(`${prefixedUrlAsset}/pub/course/homepage/list?current=1&rowCount=4`).then((response) => {
                if (response.data.data) {
                    this.videoList = response.data.data.content;
                    console.log(333,this.videoList)
                }
            });
        } ,
        moreVideos(){
            window.open('/gpassoc-user/#/courseList');
        } ,
        viewCourse(){
            window.open('/gpassoc-user/#/mine/courseList');
        } ,
    },
};
</script>

<style lang="less">
    .train{
        padding: 40px 8% 40px 10%;
        background: #F5F5F5;
        display: flex;
        .trainLeft{
            width: 55%;
            margin-right: 16px;
            .trainHead{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .title{
                    font-weight: bold;
                    font-size: 24px;
                    color: #000000;
                }
                .more{
                    font-size: 14px;
                    color: #9AA6B5;
                    cursor: pointer;
                    &:hover {
                        color: #00A287;
                        font-weight: bold;
                    }
                }
            }

        }
        .trainRight{
            width: 45%;
            .trainRightLayout{
                display: flex;
                flex-wrap: wrap;
                .imgLayout{
                    position: relative;
                    display: inline-block;
                    width: 100%;
                    cursor: pointer;   
                    &:hover {
                        transform: scale(1.1);
                    }
                    .imgStyle{
                        display: block;
                        border-radius: 16px;
                        width: 100%;
                        height:120px ;
                       
                    }
                    .imgBottom{
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        height: 35px; 
                        background-color: rgba(0, 0, 0, 0.6);
                        color: #FFFFFF;
                        border-radius: 0px 0px 16px 16px;
                        width: 100%;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0;
                        
                    }
                }
                .literalDescription{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 26px;
                    margin-top: 17px;
                    .type{
                        width: 60px;
                        height: 24px;
                        background: #13A88F;
                        border-radius: 12px 12px 12px 12px;
                        font-size: 14px;
                        color: #FFFFFF; 
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .title{
                        display: -webkit-box;
                        word-break: break-all;             
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        color: #000000;
                        margin-left: 10px;
                    }
                }
            }
        }
        
    }
    </style>